import { render, staticRenderFns } from "./CompanyAddModuleSchool.vue?vue&type=template&id=5723adfa&scoped=true&"
import script from "./CompanyAddModuleSchool.vue?vue&type=script&lang=js&"
export * from "./CompanyAddModuleSchool.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAddModuleSchool.vue?vue&type=style&index=0&id=5723adfa&prod&scoped=true&lang=scss&"
import style1 from "./CompanyAddModuleSchool.vue?vue&type=style&index=1&id=5723adfa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5723adfa",
  null
  
)

export default component.exports